import * as R from 'ramda';

const toPath = R.split(/[^\w\d]+/g);

/**
 * Deeply get a value from an object via its path.
 */
export function getIn(obj: any, key: string, def?: any, p = 0) {
    const path = toPath(key);

    while (obj && p < path.length) {
        obj = obj[path[p++]];
    }
    return obj === undefined ? def : obj;
}

/**
 * Deeply set a value from in object via its path.
 * @see https://github.com/developit/linkstate
 */
export function setIn(obj: any, path: string, value: any): any {
    const res: any = {};
    let resVal: any = res;
    let i = 0;
    const pathArray = toPath(path);

    for (; i < pathArray.length - 1; i++) {
        const currentPath: string = pathArray[i];
        const currentObj: any = getIn(
            obj,
            pathArray.slice(0, i + 1).toString(),
        );

        if (resVal[currentPath]) {
            resVal = resVal[currentPath];
        } else if (currentObj) {
            resVal = resVal[currentPath] = R.clone(currentObj);
        } else {
            const nextPath: string = pathArray[i + 1];

            const castToNum = Number.parseInt(nextPath);
            const isNumber = Number.isFinite(castToNum) && castToNum >= 0;

            resVal = resVal[currentPath] = isNumber ? [] : {};
        }
    }

    // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
        return obj;
    }

    if (value === undefined) {
        delete resVal[pathArray[i]];
    } else {
        resVal[pathArray[i]] = value;
    }

    const result = { ...obj, ...res };

    // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) {
        delete result[pathArray[i]];
    }

    return result;
}
